<template>
  <div>
    <oil-form
      :keys='keys'
      :items='report'
      :createForm='true'
      :title="'Финансовый отчет'.toUpperCase()"
      :formCallback='formCallback'
    >
      <template v-slot:saveBtn='{input,method}'>
        <v-btn disaled
               @click='method.action'
               color='primary'
               :loading='input.isLoading'
               :disabled='!input.isLoading && !report.Names'
        >
          ЗАГРУЗИТЬ
        </v-btn>
      </template>
      <template v-slot:closeBtn='{method,input}'>

        <v-btn text color='normal'
               @click='method.action'
               :disabled='!input.isLoading && !input.isEdit'
        >
          Назад
        </v-btn>
      </template>
    </oil-form>

    <!--    <embed width="800" height="800" :src="url" type="application/pdf"/>-->

  </div>

</template>
<script>
import report from './setting/contractReport.json'
import { coreApi } from '@/services/core'
import XLSX from 'xlsx'

export default {
  components: {
    OilForm: () => import('@/components/helper/oil.form')
  },
  data(){
    return{
    keys: report,
    something: '',
    testDate: '',
    url: '',
    report: {
      Names: '',
      StartDate: '',
      EndDate: ''
    },
    searchModels: {
      contractBy: {
        url: 'ContractBy',
        action: (ContractBy, status = {
          active: 'Активный',
          notsigned: 'Неподписанный',
          special: 'Особый',
          inactive: 'Неактивный'
        },) => {
          console.log(ContractBy)
          const pla = this.regular(ContractBy.Payments)
          const ras = this.regular(ContractBy.Expenses)
          const sal = this.regular(ContractBy.Caldo)
          return {
            'Покупатель': ContractBy.CompanyName,
            'Ответственный': ContractBy.waybill?.Buyer?.Dealer,
            'Номер договора': ContractBy.ContractNumber,
            'ТТН': ContractBy.waybill ?  ContractBy.ContractNumber + '-' + ContractBy.waybill?.Number : '',
            'Номер платежа':ContractBy?.Payment?.Number,
            'Платежи': (pla),
            'Расходы': (ras),
            'Сальдо': (sal),
            'Статус': status[ContractBy.Status]
          }
        }
      }
    }

    }
  },

  methods: {
    // regularr (value, fixed = 2){
    //   // const numb = parseFloat(value)
    //   // if (isNaN(value)) return '0,00'
    //   return value.toFixed(fixed)
    //     .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
    //     .replace('.', ',')
    // },
    async formCallback({ StartDate, EndDate }) {

      const name = this.report.Names
      const schema = this.searchModels[name]

      const params = {
        name: schema.url,
        start: StartDate,
        end: EndDate
      }

      const response = await coreApi.get('report', { params })

      if (!response.data || response.data?.length === 0) {
        alert('За выбранный период не было найдено записей.')
        return
      }

      try {

        const result = [
          {},
          ...response.data.map(value => {
              return {
                ...schema.action(value)
              }
            }
          )
        ]

        const data = XLSX.utils.json_to_sheet(result)
        const wb = XLSX.utils.book_new()

        XLSX.utils.book_append_sheet(wb, data, 'Расчеты')
        XLSX.writeFile(wb, 'Расчеты.xlsx')

      } catch (e) {
        console.log(e.message)
      }
    }
  }
}
</script>